import React, { useCallback, useEffect, useMemo } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import _capitalize from 'lodash/capitalize';
import _get from 'lodash/get';

import { useFeatures } from '@atc/features';

import { Col, Row } from 'reaxl';
import { sendClick } from 'reaxl-analytics';
import { inventoryDealerDiffClick } from 'reaxl-analytics-handlers';

import globalConfigsDuck from '@/ducks/globalConfigsDuck';
import vdpDealerDiffDuck from '@/ducks/vdp/vdpDealerDiffDuck.js';
import vdpResultsDuck from '@/ducks/vdp/vdpResultsDuck.js';

import DealerDiff from '@/components/DealerDiff';

export function DealerDiffContainer() {
    const listing = useSelector(vdpResultsDuck.selectors.getVdpActiveInventory);
    const aemHost = useSelector(globalConfigsDuck.selectors.getAemHost);
    const { content: dealerDiffContent } = useSelector(vdpDealerDiffDuck.selectors.getDuckState);
    const { hasDealerDiff, id: listingId, hasDealerDiffUseDeepLink, owner = {} } = listing;

    const {
        dealer_diff: [isDealerDiffEnabled],
    } = useFeatures(['dealer_diff']);
    const dispatch = useDispatch();

    useEffect(() => {
        if (isDealerDiffEnabled && hasDealerDiff) {
            dispatch(vdpDealerDiffDuck.creators.loadDealerDiff({
                dealerDiffCmsId: _get(listing, 'owner.dealerDiff.contentId', ''),
                listingType: _capitalize(listing.listingType),
            }, aemHost));
        }
    }, [listingId]); // eslint-disable-line react-hooks/exhaustive-deps

    const handleDealerDiffCTAClick = useCallback((event, label) => {
        const { id: inventoryId, ecommWebsite = {} } = listing;
        let eventElement;
        let cmp;

        const eventResult = {
            prefix: 'button::',
            ctaLabel: label,
        };

        if (Object.keys(ecommWebsite).length) {
            eventResult.prefix = 'sitelink::ecomm-deeplink::';
            eventElement = 'dealer';
            cmp = 'str_now_ecomm_dplink';
        }

        sendClick(inventoryDealerDiffClick, event, { eventResult, eventElement, cmp, inventoryId });
    }, [listing]);

    const getDealerDiffCTA = useCallback((cta) => {
        const { website } = owner || {};
        if (hasDealerDiffUseDeepLink && website?.deepLink) { // check for owner product and deeplink
            return ({
                label: cta.label,
                link: website.href,
                offsite: website.deepLink,
            });
        }
        return cta;
    }, [hasDealerDiffUseDeepLink, owner]);

    const dealerDiffProps = useMemo(() => {
        const props = { ...dealerDiffContent };
        if (dealerDiffContent.cta) {
            props.cta = {
                ...getDealerDiffCTA(dealerDiffContent.cta),
                onClick: (event) => handleDealerDiffCTAClick(event, dealerDiffContent.cta.label),
            };
        }
        return props;
    }, [dealerDiffContent, getDealerDiffCTA, handleDealerDiffCTAClick]);

    if (!isDealerDiffEnabled || !hasDealerDiff || !Object.keys(dealerDiffContent).length) return null;

    return (
        <div className="container">
            <Row>
                <Col
                    className="margin-top-4 margin-top-md-5 dealer-diff"
                    xs={12}
                    sm={10}
                    md={7}
                >
                    <DealerDiff
                        isLeftAligned
                        {...dealerDiffProps}
                    />
                </Col>
            </Row>
        </div>
    );
}

export default DealerDiffContainer;
